<template>
  <div class="city-footer">
    <h4 data-anim="title">next stop</h4>

    <router-link
      :to="cityfooter.urlNext"
    >
      <CityFooterImage :data="cityfooter" />
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import CityFooterImage from '@/components/CityFooterImage';

export default {
  name: 'CityFooter',

  components: {
    CityFooterImage,
  },

  data() {
    return {
      cityfooter: {},
    };
  },

  computed: {
    ...mapGetters(['getDataCityComponent']),
  },

  created() {
    this.cityfooter = this.getDataCityComponent(this.$route.params.city, 'cityfooter');
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/colors';
@import '../application';

.city-footer {
  position: relative;
  padding: 0 20px 100px;

  text-align: center;

  z-index: 2;

  @include mq(sm) {
    padding: 100px 100px 120px 100px;
  }

  h4 {
    color: $color-gray;
    font-family: 'Neutral';
    font-weight: normal;
    font-style: italic;

    @include mq(sm) {
      padding-bottom: 60px;
    }
  }

  &::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50%;
    background-color: $color-black;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CityFooter.vue